<template>
  <AuthForm
    :can-submit="canBeSubmitted"
    :error="form.error"
    :submitted="form.submitted"
    type="login"
    @submit="submit"
  >
    <FormInput
      :model-value="form.fields.code.value"
      label="Code"
      name="code"
      type="tel"
      @update:modelValue="(newValue) => (form.fields.code = newValue)"
    />
  </AuthForm>
</template>

<script>
import AuthForm from '@/components/form/auth/AuthForm.vue'
import { FormInput } from '@/components/form/fields'
import { AuthFormCanBeSubmittedMixin } from '@/components/form/mixins'

export default {
  name: 'AuthConfirmation',
  mixins: [AuthFormCanBeSubmittedMixin],
  components: { AuthForm, FormInput },
  data() {
    return {
      form: {
        error: null,
        fields: {
          code: {
            valid: false,
            value: null,
          },
        },
        submitted: false,
      },
    }
  },
  methods: {
    async submit() {
      this.form.error = null
      this.form.submitted = true
      const error = await this.$store.dispatch('verify', { code: this.form.fields.code.value })

      this.form.submitted = false
      this.form.error = error
    },
  },
  watch: {
    'form.fields.code.value'() {
      this.form.error = null
    },
  },
}
</script>
